import { useTranslation } from 'react-i18next';
import { Modal, ModalActionType, ModalVariant } from '@/components/Modal';
import { I18nNamespace } from '@/lib/i18n-namespaces';

interface ReanalyzeSourceConfirmationModalProps {
    isOpen: boolean;
    submitInProgress: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

export function ReanalyzeSourceConfirmationModal({
    isOpen,
    submitInProgress,
    onConfirm,
    onCancel,
}: ReanalyzeSourceConfirmationModalProps) {
    const { t } = useTranslation(I18nNamespace.SOURCES);

    return (
        <Modal
            isOpen={isOpen}
            title={t('reanalyzeConfirmTitle')}
            description={t('reanalyzeConfirmDescription')}
            onCancel={onCancel}
            onSubmit={onConfirm}
            submitInProgress={submitInProgress}
            submitText={t('actions.reanalyze')}
            maxWidth="max-w-[471px]"
            variant={ModalVariant.PLAIN}
            actionType={ModalActionType.DANGER}
            closeOnOutsideClick
        />
    );
}
